<template>
  <div class="box">
    {{number}}
    <img v-show="voice_play" class="img" src="/assets/image/trumpet_start.gif" alt="音頻播放中">
    <img v-show="!voice_play" class="img" src="/assets/image/trumpet_stop.png" alt="音頻" @click="playVoice">
  </div>
</template>

<script>
export default {
  name: "TestQuizNumber",
  props: {
    number: {type: String},
    voice_play: {type: Boolean, default: false},
  },
  methods: {
    playVoice: function () {
      this.$emit('playVoice');
    }
  }
}
</script>

<style scoped>
  .box{
    font-size: var(--ecs-font-md);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: clamp(0.5rem, 1.5vw, 1rem);
    margin-bottom: clamp(1rem, 2.5vw, 1.75rem);
  }
  .img{
    display: block;
    width: clamp(2.25rem, 5vw, 3.5rem);
  }
</style>
